export default {
  'header.menu.purpose': 'Association Introduction & Mission',
  'header.menu.join': 'Association Rules & Membership Guide',
};
